module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/join/step-screen-2-577ec042afca7bcc455af076d6ca4ad2.png";